import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DateRange, Percentage } from '~/modules/common/components';
import { ResourceAllocationRequestStatusBadge } from '~/modules/common/components/ResourceAllocationRequestStatusBadge';
import EntityName from '~/modules/common/components/entities/common/EntityName';
import { ResourceAllocationStatus } from '~/types';

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: theme.typography.fontWeightBold
  },
  projectName: {
    fontSize: theme.typography.caption.fontSize
  },
  projectList: {
    padding: 0,
    margin: theme.spacing(1, 0, 0, 0),
    listStyle: 'none',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, auto)',
    gridTemplateRows: 'auto',
    gridColumnGap: 0,
    gridRowGap: 0
  },
  allocationItem: {
    padding: 0,
    margin: 0,
    display: 'contents'
  },
  value: {
    textAlign: 'left',
    paddingRight: theme.spacing(1)
  },
  label: {
    textAlign: 'left'
  },
  totalItem: {
    '& $percentage, & $label': {
      fontWeight: theme.typography.fontWeightBold,
      borderTop: '1px solid #fff'
    }
  }
}));

const useDateStyles = makeStyles(theme => ({
  date: {
    fontSize: theme.typography.caption.fontSize
  }
}));

export const UserAllocationSummaryTooltipContent = ({
  startDate,
  endDate,
  load,
  allocationDistributionItems,
  hideTotalAllocationLabel = false
}) => {
  const classes = useStyles();
  const dateClasses = useDateStyles();

  return (
    <>
      <div className={classes.title}>
        <DateRange start={startDate} end={endDate} classes={dateClasses} />
        <br />
      </div>
      <ul className={classes.projectList}>
        {allocationDistributionItems.map(item => (
          <li
            key={`${item.name}_${item.allocationStatus}`}
            className={classes.allocationItem}
          >
            <Percentage
              className={classes.value}
              value={item.load}
              fixedDecimalScale={false}
            />
            <EntityName className={classes.projectName} name={item.name} />
            {item.allocationStatus &&
            item.allocationStatus !== ResourceAllocationStatus.Committed ? (
              <ResourceAllocationRequestStatusBadge
                status={item.allocationStatus}
              />
            ) : (
              <span></span>
            )}
          </li>
        ))}
        {!hideTotalAllocationLabel && (
          <li className={classNames(classes.allocationItem, classes.totalItem)}>
            <Percentage
              className={classes.value}
              value={load}
              fixedDecimalScale={false}
            />
            <span className={classes.label}>
              <FormattedMessage id="resourceAllocationSummaryTooltip.allocated" />
            </span>
            <span className={classes.label}></span>
          </li>
        )}
      </ul>
    </>
  );
};

UserAllocationSummaryTooltipContent.propTypes = {
  startDate: PropTypes.object.isRequired,
  endDate: PropTypes.object.isRequired,
  load: PropTypes.number.isRequired,
  allocationDistributionItems: PropTypes.array,
  hideTotalAllocationLabel: PropTypes.bool
};

export default UserAllocationSummaryTooltipContent;
